var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-desktop-container horizontal center around",
      on: { mouseleave: _vm.hideNav }
    },
    [
      _vm.headerLinks.length
        ? _c(
            "div",
            { staticClass: "headerlink-container" },
            _vm._l(_vm.headerLinks, function(headerLink) {
              return _c("f9link", {
                key: headerLink.id,
                staticClass: "nav-link",
                attrs: {
                  "new-window": headerLink.newWindow,
                  nostyle: "",
                  href: _vm.getLink(headerLink.link)
                },
                domProps: { innerHTML: _vm._s(headerLink.text) }
              })
            })
          )
        : _c(
            "div",
            { staticClass: "nav-desktop-container horizontal center around" },
            [
              _c(
                "div",
                { staticClass: "nav-header-item travel" },
                [
                  _c("f9link", {
                    staticClass: "nav-link",
                    attrs: {
                      nostyle: "",
                      href: _vm.getLink(_vm.menuData.travel.link.link),
                      "new-window": _vm.menuData.travel.link.newWindow,
                      "aria-expanded": _vm.showTravel
                    },
                    domProps: { innerHTML: _vm._s(_vm.menuData.travel.name) },
                    nativeOn: {
                      focus: function($event) {
                        _vm.hoverNav("Travel")
                      },
                      mouseover: function($event) {
                        _vm.hoverNav("Travel")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showTravel,
                        expression: "showTravel"
                      }
                    ],
                    staticClass: "arrow"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showTravel,
                      expression: "showTravel"
                    }
                  ],
                  ref: "navItems",
                  staticClass: "nav-items body-width travel"
                },
                [
                  _c(
                    "div",
                    { staticClass: "nav-item-header horizontal center left" },
                    [_vm._v(_vm._s(_vm.menuData.travel.name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "nav-item-content horizontal top between" },
                    _vm._l(_vm.menuData.travel.sections, function(section) {
                      return _c(
                        "div",
                        {
                          key: section.id,
                          staticClass: "nav-section vertical left"
                        },
                        [
                          _c("div", {
                            staticClass: "nav-section-sub-head",
                            domProps: { innerHTML: _vm._s(section.name) }
                          }),
                          _vm._v(" "),
                          _vm._l(section.links, function(link) {
                            return _c("f9link", {
                              key: link.id,
                              staticClass: "full-width nav-section-item",
                              attrs: {
                                "new-window": link.newWindow,
                                nostyle: "",
                                href: _vm.getLink(link.link)
                              },
                              domProps: { innerHTML: _vm._s(link.caption) }
                            })
                          })
                        ],
                        2
                      )
                    })
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "nav-header-item deals" },
                [
                  _c("f9link", {
                    staticClass: "nav-link",
                    attrs: {
                      nostyle: "",
                      href: _vm.getLink(_vm.menuData.deals.link.link),
                      "new-window": _vm.menuData.deals.link.newWindow,
                      "aria-expanded": _vm.showDeals
                    },
                    domProps: { innerHTML: _vm._s(_vm.menuData.deals.name) },
                    nativeOn: {
                      focus: function($event) {
                        _vm.hoverNav("Deals")
                      },
                      mouseover: function($event) {
                        _vm.hoverNav("Deals")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDeals,
                        expression: "showDeals"
                      }
                    ],
                    staticClass: "arrow"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDeals,
                      expression: "showDeals"
                    }
                  ],
                  ref: "navItems",
                  staticClass: "nav-items body-width deals"
                },
                [
                  _c("div", {
                    staticClass: "nav-item-header horizontal center left",
                    domProps: { innerHTML: _vm._s(_vm.menuData.deals.name) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "nav-item-content horizontal top between" },
                    [
                      _c(
                        "div",
                        { staticClass: "nav-section" },
                        [
                          _c("div", {
                            staticClass: "nav-section-sub-head",
                            domProps: {
                              innerHTML: _vm._s(_vm.menuData.deals.section.name)
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.menuData.deals.section.links, function(
                            link,
                            index
                          ) {
                            return _c("f9link", {
                              key: link.id,
                              staticClass: "nav-section-item row-cb",
                              class: { highlighted: index === 0 },
                              attrs: {
                                "new-window": link.newWindow,
                                nostyle: "",
                                href: _vm.getLink(link.link)
                              },
                              domProps: { innerHTML: _vm._s(link.caption) }
                            })
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "nav-section extra no-pad" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card full-width to-edge green-background-light horizontal center between"
                          },
                          [
                            _c("img", {
                              staticClass: "card-img",
                              attrs: {
                                src: _vm.menuData.deals.creditCard.imageUrl,
                                alt: _vm.menuData.deals.creditCard.imageAlt
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "card-text vertical center left",
                              domProps: {
                                innerHTML: _vm._s(_vm.creditCardText)
                              }
                            }),
                            _vm._v(" "),
                            !_vm.member.isBarclaysMember
                              ? _c("f9link", {
                                  staticClass: "card-button horizontal center",
                                  attrs: {
                                    nostyle: "",
                                    "new-window":
                                      _vm.menuData.deals.creditCard.link
                                        .newWindow,
                                    href: _vm.getLink(
                                      _vm.menuData.deals.creditCard.link.link
                                    )
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.menuData.deals.creditCard.link.caption
                                    )
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.member.isBarclaysMember
                          ? _c("div", {
                              staticClass: "terms",
                              domProps: {
                                innerHTML: _vm._s(_vm.menuData.deals.subText)
                              }
                            })
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "nav-header-item frontier" },
                [
                  _c(
                    "f9link",
                    {
                      staticClass: "nav-link horizontal top around",
                      attrs: {
                        nostyle: "",
                        href: _vm.getLink(_vm.menuData.myFrontier.link.link),
                        "new-window": _vm.menuData.myFrontier.link.newWindow,
                        "aria-expanded": _vm.showFrontier
                      },
                      nativeOn: {
                        focus: function($event) {
                          _vm.hoverNav("Frontier")
                        },
                        mouseover: function($event) {
                          _vm.hoverNav("Frontier")
                        }
                      }
                    },
                    [
                      _c("i", {
                        domProps: {
                          innerHTML: _vm._s(_vm.menuData.myFrontier.name)
                        }
                      }),
                      _vm._v("\n                 Miles\n            ")
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showFrontier,
                        expression: "showFrontier"
                      }
                    ],
                    staticClass: "arrow"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showFrontier,
                      expression: "showFrontier"
                    }
                  ],
                  ref: "navItems",
                  staticClass: "nav-items body-width frontier"
                },
                [
                  _c(
                    "div",
                    { staticClass: "nav-item-header horizontal center left" },
                    [
                      _c("i", {
                        domProps: {
                          innerHTML: _vm._s(_vm.menuData.myFrontier.name)
                        }
                      }),
                      _vm._v("\n                 Miles\n                "),
                      _c("span", { staticClass: "sm" }, [_vm._v("sm")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "nav-item-content horizontal top stretch" },
                    [
                      _c(
                        "div",
                        { staticClass: "nav-section full-height" },
                        [
                          _c("div", {
                            staticClass: "nav-section-sub-head",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.menuData.myFrontier.leftSection.name
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(
                            _vm.menuData.myFrontier.leftSection.links,
                            function(link) {
                              return _c("f9link", {
                                key: link.id,
                                staticClass: "nav-section-item row-cb",
                                attrs: {
                                  "new-window": link.newWindow,
                                  nostyle: "",
                                  href: _vm.getLink(link.link)
                                },
                                domProps: { innerHTML: _vm._s(link.caption) }
                              })
                            }
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.member.isLoggedIn
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "nav-section full-height vertical top left"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "nav-section-sub-head" },
                                [
                                  _vm._v("Earn Miles! "),
                                  _c(
                                    "f9button",
                                    {
                                      staticClass: "signup-link",
                                      attrs: { nostyle: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.$emit("signup")
                                        }
                                      }
                                    },
                                    [_vm._v("SIGN UP TODAY")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._m(0),
                              _vm._v(" "),
                              _vm._m(1),
                              _vm._v(" "),
                              _vm._m(2)
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "nav-section full-height vertical left between no-pad"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "vertical left to-edge" },
                                [
                                  _c("div", {
                                    staticClass: "nav-section-sub-head",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.menuData.myFrontier.rightSection
                                          .name
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.menuData.myFrontier.rightSection.links,
                                    function(link) {
                                      return _c("f9link", {
                                        key: link.id,
                                        staticClass:
                                          "nav-section-item row-cb auto",
                                        attrs: {
                                          "new-window": link.newWindow,
                                          nostyle: "",
                                          href: _vm.getLink(link.link)
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(link.caption)
                                        }
                                      })
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        focusout: function($event) {
                                          {
                                            _vm.member.isBarclaysMember &&
                                            _vm.member.isDiscountDenMember
                                              ? _vm.hideNav()
                                              : null
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "f9button",
                                        {
                                          staticClass:
                                            "a nav-section-item row-cb auto",
                                          attrs: { nostyle: "" },
                                          on: { click: _vm.logout }
                                        },
                                        [_vm._v("Logout")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "my-frontier-links full-width to-edge"
                                },
                                [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.menuData.myFrontier
                                      .accountOverviewSections,
                                    function(section, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: section.id,
                                          staticClass:
                                            "my-section horizontal center between full-width",
                                          class: {
                                            "green-background-light": _vm.getMyFrontierDataPoint(
                                              index
                                            )
                                          }
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(section.name)
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.getMyFrontierDataPoint(index)
                                            ? _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    section.existing
                                                  )
                                                }
                                              })
                                            : _c(
                                                "span",
                                                _vm._l(section.links, function(
                                                  link
                                                ) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: link.id,
                                                      on: {
                                                        focusout: function(
                                                          $event
                                                        ) {
                                                          {
                                                            _vm.lastMyFrontierLink(
                                                              index
                                                            )
                                                              ? _vm.hideNav()
                                                              : null
                                                          }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("f9link", {
                                                        key: link.index,
                                                        staticClass:
                                                          "auto my-link",
                                                        attrs: {
                                                          "new-window":
                                                            link.newWindow,
                                                          nostyle: "",
                                                          href: _vm.getLink(
                                                            link.link
                                                          )
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            link.caption
                                                          )
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                })
                                              )
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ]
                          ),
                      _vm._v(" "),
                      !_vm.member.isLoggedIn
                        ? _c(
                            "div",
                            {
                              staticClass: "nav-section horizontal pointer",
                              on: { focusout: _vm.hideNav }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      _vm.menuData.myFrontier
                                        .rightSectionImageAndLinkNotSignedIn
                                        .umbracoLink.link,
                                    target:
                                      _vm.myFrontierRightSectionLinkNewWindow
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.menuData.myFrontier
                                          .rightSectionImageAndLinkNotSignedIn
                                          .imgSrc,
                                      alt:
                                        _vm.menuData.myFrontier
                                          .rightSectionImageAndLinkNotSignedIn
                                          .imgAlt
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            ]
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-section-item center left" }, [
      _c("i", { staticClass: "img checkmark" }),
      _c("span", [
        _vm._v(
          "Earn Miles and Points for every $1 you spend at Flyfrontier.com!"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-section-item center left" }, [
      _c("i", { staticClass: "img checkmark" }),
      _c("span", [_vm._v("Redeem Travel Miles for award flights!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-section-item center left" }, [
      _c("i", { staticClass: "img checkmark" }),
      _c("span", [
        _vm._v(
          "Gain points to achieve Elite Status and get FREE bags, seats, and additional benefits"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "nav-section-sub-head horizontal top left" },
      [
        _c("i", [_vm._v("FRONTIER Miles")]),
        _c("span", { staticClass: "sm" }, [_vm._v("sm")]),
        _vm._v(" "),
        _c("span", [_vm._v("ACCOUNT OVERVIEW")])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a1cbfd0", { render: render, staticRenderFns: staticRenderFns })
  }
}